/* eslint-disable array-bracket-newline */
/**
 * Shows Connect button or balance
 */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Network } from '@kattana-io/common';
import { useAccount, useNetwork } from 'wagmi';
import { actionShowModal } from '../../actions/modal';
import { ModalTypes } from '../../reducers/modal';
import WalletSelect from './walletSelect';
import wallet from '../../assets/images/wallet.svg';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import Button from '../../molecules/Button';
import { toFixed4 } from '../DexTrades/formatters';
import { formatAddress } from '../../helpers/formatters';
import { useWallet } from '../../wallet/walletContext';

import './styles.scss';

const ConnectedWallet = () => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const [isWalletSelect, setWalletSelect] = useState(false);
  const [network, setNetwork] = useState<Network | undefined>(
    Network.fromChainId(1)
  );
  const dispatch = useDispatch();

  const {
    isConnecting,
    isSignLoading,
    onDisconnect,
    state: { error, tokenRatesBySym, tokenBalancesBySym, loading, tokensBySym },
  } = useWallet();

  /**
   * Call the modal for connecting new wallet
   */
  const onConnect = () => {
    if (!isConnecting) {
      dispatch(actionShowModal(ModalTypes.connect, {}));
    }
  };

  /**
   * Change of address/chain effects
   */
  useEffect(() => {
    if (chain?.id != network?.toDecimal()) {
      setNetwork(Network.fromChainId(chain?.id));
    }
  }, [chain]);

  if (address && network) {
    const nativeToken = network.getNativeCurrencySymbol();
    const onCopyAddress = () => {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          console.log('Copied to clipboard');
        })
        .catch((err) => {
          console.warn('Could not copy to clipboard', err);
        });
    };

    const onScan = () => {
      const link = network.getScanForWallet() || '';
      window.open(`${link}${address}`);
    };

    const onWalletSelectClose = () => {
      setWalletSelect(false);
    };

    const onLogout = () => {
      onDisconnect();
      onWalletSelectClose();
    };

    return (
      <>
        <div className='connected_wallet'>
          <div
            className='connected_wallet__info'
            onClick={() => setWalletSelect(!isWalletSelect)}
          >
            {loading ? (
              <div className='balance__loading' />
            ) : (
              <Text size={14} className='text--grey-400 balance'>
                {toFixed4(Number(tokenBalancesBySym[nativeToken] || 0))}
                &nbsp;{nativeToken}
              </Text>
            )}
            <div className='address'>{formatAddress(address)}</div>
          </div>
          <div className='connected_wallet__actions'>
            <div
              className='connected_wallet__actions__icon icon-copy'
              onClick={onCopyAddress}
            />
            <div
              className='connected_wallet__actions__icon icon-top-right-square'
              onClick={onScan}
            />
          </div>
        </div>

        {isWalletSelect && (
          <>
            <div
              className='connected_wallet__backdrop'
              onClick={onWalletSelectClose}
            />
            <WalletSelect
              error={error}
              loading={loading}
              mapping={tokensBySym}
              rates={tokenRatesBySym}
              balances={tokenBalancesBySym}
              network={network}
              currentWallet={{
                address,
                amount: toFixed4(
                  Number(tokenBalancesBySym[nativeToken] || 0)
                ),
                nativeToken,
              }}
              onConnect={() => {
                onDisconnect();
                dispatch(actionShowModal(ModalTypes.connect, {}));
              }}
              onLogout={onLogout}
              onClose={onWalletSelectClose}
            />
          </>
        )}
      </>
    );
  }

  const contents =
    isConnecting || isSignLoading ? (
      <Text size={12}>Connecting</Text>
    ) : (
      <>
        <Image src={wallet} size='m' />
        <Text size={12}>Connect wallet</Text>
      </>
    );

  return (
    <div className='connect_btn'>
      <Button
        action={onConnect}
        size={'s'}
        variant={'primary'}
        component={contents}
      />
    </div>
  );
};

export default ConnectedWallet;
